"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _constants = require("../constants");

var _keycode = _interopRequireDefault(require("keycode"));

var _tabbable = require("tabbable");

// ie
if (global.Element && !Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

if (typeof NodeList !== 'undefined' && NodeList.prototype && !(0, _forEach.default)(NodeList.prototype)) {
  NodeList.prototype.forEach = (0, _forEach.default)(Array.prototype);
}

var GridManager = /*#__PURE__*/function () {
  function GridManager() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, GridManager);

    this.setupFocusGrid = function () {
      _this.grid = [];
      var skippedRows = 0;
      _this.gridNode && (0, _forEach.default)(Array.prototype).call(_this.gridNode.querySelectorAll(_constants.GridSelector.ROW), function (row, rowIndex) {
        var rowCells = [];
        var cellIndex = 0;

        if (_this.rowNavigation) {
          row.setAttribute('tabindex', -1);
        }

        (0, _forEach.default)(Array.prototype).call(row.querySelectorAll(_this.cellSelector), function (cell) {
          var colSpan = cell.colSpan;
          cell.setAttribute('tabindex', -1);
          cell.addEventListener('focus', _this.handleFocusCell);

          for (var i = 1; i <= colSpan; i++) {
            rowCells.push({
              row: rowIndex - skippedRows,
              col: cellIndex,
              element: cell,
              rowElement: row,
              focusableElements: cell.querySelectorAll(_constants.GridSelector.FOCUSABLE),
              editableElement: cell.querySelector(_constants.GridSelector.EDITABLE)
            });
            cellIndex++;
          }
        });

        if (rowCells.length) {
          _this.grid.push(rowCells);
        } else {
          skippedRows++;
        }
      });

      _this.toggleTabbableElements(false, _this.getAllFocusableElements(false));
    };

    this.clearEvents = function () {
      var _this$gridNode, _this$gridNode2;

      (_this$gridNode = _this.gridNode) === null || _this$gridNode === void 0 ? void 0 : _this$gridNode.removeEventListener('keydown', _this.handleKeyDown);
      (_this$gridNode2 = _this.gridNode) === null || _this$gridNode2 === void 0 ? void 0 : _this$gridNode2.removeEventListener('mouseup', _this.handleClickCell);
    };

    this.registerEvents = function () {
      var _this$gridNode3, _this$gridNode4;

      _this.clearEvents();

      (_this$gridNode3 = _this.gridNode) === null || _this$gridNode3 === void 0 ? void 0 : _this$gridNode3.addEventListener('keydown', _this.handleKeyDown);
      (_this$gridNode4 = _this.gridNode) === null || _this$gridNode4 === void 0 ? void 0 : _this$gridNode4.addEventListener('mouseup', _this.handleClickCell);
    };

    this.getCellProperties = function (element, knownCoordinates) {
      var cellCoordinates = knownCoordinates ? knownCoordinates : _this.getCellCoordinates(element);
      var cell;

      if (cellCoordinates) {
        cell = _this.grid[cellCoordinates.row][cellCoordinates.col];
      }

      return cell;
    };

    this.getCellCoordinates = function (element) {
      for (var row = 0; row < _this.grid.length; row++) {
        for (var col = 0; col < _this.grid[row].length; col++) {
          if (element && (_this.grid[row][col].element === element || _this.grid[row][col].element.contains(element) || element.contains(_this.grid[row][col].element))) {
            return {
              row: row,
              col: col
            };
          }
        }
      }

      return null;
    };

    this.getCurrentCellProperties = function () {
      return _this.grid[_this.focusedRow][_this.focusedCol];
    };

    this.setFocusPointer = function (row, col) {
      if (_this.isValidCell({
        row: row,
        col: col
      })) {
        var currentCell = _this.grid[_this.focusedRow][_this.focusedCol];
        var nextCell = _this.grid[row][col];
        var elementProp = !_this.rowNavigation ? 'element' : 'rowElement';

        if (!_this.editMode) {
          currentCell[elementProp].setAttribute('tabindex', -1);
          nextCell[elementProp].setAttribute('tabindex', 0);
        }

        _this.focusedRow = row;
        _this.focusedCol = col;
      }
    };

    this.isValidCell = function (cell) {
      if (cell) {
        var row = cell.row,
            col = cell.col;
        return !isNaN(row) && !isNaN(col) && row >= 0 && col >= 0 && _this.grid && _this.grid.length && row < _this.grid.length && col < _this.grid[row].length;
      } else {
        return false;
      }
    };

    this.isEditableCell = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          focusableElements = _ref.focusableElements,
          editableElement = _ref.editableElement;

      return (focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements.length) > 1 || editableElement;
    };

    this.focusCell = function (nextCell, event) {
      var row = nextCell.row,
          col = nextCell.col,
          element = nextCell.element,
          focusableElements = nextCell.focusableElements;

      _this.setFocusPointer(row, col);

      var posX = window.pageXOffset;
      var posY = window.pageYOffset;

      if (_this.editMode) {
        // only redirect focus upon clicking or entering edit mode on table cell element
        if (event.target === element) {
          var _focusableElements$;

          (_focusableElements$ = focusableElements[0]) === null || _focusableElements$ === void 0 ? void 0 : _focusableElements$.focus();
        }
      } else {
        element.focus();
      }

      window.scrollTo(posX, posY);
    };

    this.handleFocusCell = function (event) {
      if (event.target.matches && event.target.matches(_this.cellSelector)) {
        var _cell$focusableElemen;

        var cell = _this.getCellProperties(event.target);

        if (!_this.rowNavigation && ((_cell$focusableElemen = cell.focusableElements) === null || _cell$focusableElemen === void 0 ? void 0 : _cell$focusableElemen.length) === 1 && !cell.focusableElements[0].matches(_constants.GridSelector.EDITABLE)) {
          cell.focusableElements[0].focus();
        } else if (_this.rowNavigation) {
          var _cell$rowElement;

          (_cell$rowElement = cell.rowElement) === null || _cell$rowElement === void 0 ? void 0 : _cell$rowElement.focus();
        }

        _this.onFocusCell(cell, event);
      }
    };

    this.toggleEditMode = function (currentCell, enable) {
      _this.editMode = !!enable;
      var elementProp = !_this.rowNavigation ? 'element' : 'rowElement';
      currentCell[elementProp].setAttribute('tabindex', enable ? -1 : 0);

      var focusableElements = _this.getAllFocusableElements(_this.skipFirstColumnTabbing);

      _this.toggleTabbableElements(enable, focusableElements);

      if (focusableElements.length > 0) {
        _this.onToggleEditMode(enable);
      }
    };

    this.getAllFocusableElements = function (skipFirstColumn) {
      var _context;

      var focusableElements = [];
      (0, _forEach.default)(_context = _this.grid).call(_context, function (row) {
        (0, _forEach.default)(row).call(row, function (cell) {
          if (!(_this.rowNavigation && skipFirstColumn && (cell === null || cell === void 0 ? void 0 : cell.col) === 0)) {
            var _context2;

            focusableElements = (0, _concat.default)(_context2 = []).call(_context2, (0, _toConsumableArray2.default)(focusableElements), (0, _toConsumableArray2.default)(cell === null || cell === void 0 ? void 0 : cell.focusableElements));
          }
        });
      });
      return focusableElements;
    };

    this.toggleTabbableElements = function (enable, focusableElements) {
      if (focusableElements.length) {
        (0, _forEach.default)(focusableElements).call(focusableElements, function (element) {
          element.setAttribute('tabindex', enable ? 0 : -1);
        });
      }
    };

    this.handleKeyDown = function (event) {
      var key = event.which || event.keyCode;
      var currentCell = _this.grid[_this.focusedRow][_this.focusedCol];
      var nextCell = currentCell;
      var pressedNavigationalKey = false;

      switch (key) {
        case _keycode.default.codes.up:
          nextCell = _this.getNextCell(currentCell, 0, -1);
          pressedNavigationalKey = true;
          break;

        case _keycode.default.codes.down:
          nextCell = _this.getNextCell(currentCell, 0, 1);
          pressedNavigationalKey = true;
          break;

        case _keycode.default.codes.left:
          if (!_this.rowNavigation) {
            nextCell = _this.getNextCell(currentCell, -1, 0);
            pressedNavigationalKey = true;
          }

          break;

        case _keycode.default.codes.right:
          if (!_this.rowNavigation) {
            nextCell = _this.getNextCell(currentCell, 1, 0);
            pressedNavigationalKey = true;
          }

          break;

        case _keycode.default.codes.home:
          if (!_this.rowNavigation) {
            nextCell = _this.getNextCell({
              row: _this.focusedRow,
              col: -1
            }, 1, 0);
            pressedNavigationalKey = true;
          }

          break;

        case _keycode.default.codes.end:
          if (!_this.rowNavigation) {
            nextCell = _this.getNextCell({
              row: _this.focusedRow,
              col: _this.grid[_this.focusedRow].length
            }, -1, 0);
            pressedNavigationalKey = true;
          }

          break;

        case _keycode.default.codes.enter:
          if (!_this.rowNavigation) {
            if (event.target.matches(_this.cellSelector)) {
              event.preventDefault();
            }

            if (_this.isEditableCell(currentCell) && !event.target.matches(_constants.GridSelector.HAS_ENTER_KEY_HANDLING)) {
              _this.toggleEditMode(currentCell, !_this.editMode);
            }

            if (!_this.editMode) {
              nextCell = _this.getParentCell(event.target);
            }
          } else {
            if (event.target.matches(_constants.GridSelector.ROW)) {
              _this.onClickRow(currentCell, event);
            }
          }

          break;

        case _keycode.default.codes.esc:
          _this.toggleEditMode(currentCell, false);

          nextCell = _this.getParentCell(event.target);
          break;

        case _keycode.default.codes.tab:
          if (!_this.editMode) {
            if (!_this.rowNavigation) {
              var nextElement = _this.getNextOutsideTabbableElement(event.shiftKey);

              nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
              event.preventDefault();
            } else if (currentCell.row > 0 && !event.shiftKey) {
              // don't activate edit mode if shift-tabbing away from table
              _this.toggleEditMode(currentCell, true);
            }
          }

          return;

        default:
          _this.onKeyDownCell(nextCell, event);

          return;
      }

      if (nextCell) {
        _this.focusCell(nextCell, event);

        _this.onKeyDownCell(nextCell, event);
      }

      if (!_this.editMode && pressedNavigationalKey) {
        event.preventDefault();
      }
    };

    this.handleClickCell = function (event) {
      // reset current edit state
      var currentCell = _this.grid[_this.focusedRow][_this.focusedCol];

      if (_this.isEditableCell(currentCell) && _this.editMode) {
        _this.toggleEditMode(currentCell, false);
      }

      var clickedGridCell = _this.getParentCell(event.target);

      if (_this.isEditableCell(clickedGridCell)) {
        _this.toggleEditMode(clickedGridCell, true);
      }

      if (clickedGridCell) {
        _this.focusCell(clickedGridCell, event);
      }
    };

    this.didPassBoundary = function (rowLength, candidateRow, candidateCol, directionX, directionY) {
      if (directionX === -1) {
        return candidateRow < 0 || !_this.wrapRows && candidateCol < 0;
      } else if (directionX === 1) {
        return candidateRow >= _this.grid.length || !_this.wrapRows && candidateCol >= rowLength;
      } else if (directionY === -1) {
        return candidateCol < 0 || !_this.wrapCols && candidateRow < 0;
      } else if (directionY === 1) {
        return candidateCol >= rowLength || !_this.wrapCols && candidateRow >= _this.grid.length;
      }

      return false;
    };

    this.getNextCell = function (currentCell, directionX, directionY) {
      // directionX: 1 = right, -1 = left
      // directionY: 1 = down, -1 = up
      if (_this.editMode) {
        return null;
      }

      var nextCell = currentCell;

      if (currentCell) {
        if (directionX !== 0) {
          // horizontal
          var candidateRow = currentCell.row;
          var candidateCol = currentCell.col;

          do {
            candidateCol += directionX;

            if (candidateRow > _this.grid.length - 1) {
              candidateRow = _this.grid.length - 1;
            }

            var rowLength = _this.grid[candidateRow].length;

            if (_this.wrapRows) {
              if (directionX === 1 && candidateCol >= rowLength) {
                candidateRow++;
                candidateCol = 0;
              } else if (directionX === -1 && candidateCol < 0) {
                candidateRow--;
                candidateCol = rowLength - 1;
              }
            }

            if (_this.didPassBoundary(rowLength, candidateRow, candidateCol, directionX, directionY)) {
              _this.onPassBoundary({
                currentCell: currentCell,
                directionX: directionX,
                directionY: directionY
              });

              return null;
            }
          } while (!_this.isValidCell({
            row: candidateRow,
            col: candidateCol
          }) || _this.isDisabledCell(_this.grid[candidateRow][candidateCol].element) || _this.grid[candidateRow][candidateCol].element === currentCell.element);

          nextCell = _this.grid[candidateRow][candidateCol];
        } else if (directionY !== 0) {
          // vertical
          var _candidateRow = currentCell.row;
          var _candidateCol = currentCell.col;

          do {
            _candidateRow += directionY;

            var _rowLength = _this.grid[currentCell.row] ? _this.grid[currentCell.row].length : 0;

            if (_this.wrapCols) {
              if (directionY === 1 && _candidateRow >= _this.grid.length) {
                _candidateCol++;
                _candidateRow = 0;
              } else if (directionY === -1 && _candidateRow < 0) {
                _candidateCol--;
                _candidateRow = _this.grid.length - 1;
              }
            }

            if (_this.didPassBoundary(_rowLength, _candidateRow, _candidateCol, directionX, directionY)) {
              _this.onPassBoundary({
                currentCell: currentCell,
                directionX: directionX,
                directionY: directionY
              });

              return null;
            }
          } while (!_this.isValidCell({
            row: _candidateRow,
            col: _candidateCol
          }) || _this.isDisabledCell(_this.grid[_candidateRow][_candidateCol].element) || _this.grid[_candidateRow][_candidateCol].element === currentCell.element);

          nextCell = _this.grid[_candidateRow][_candidateCol];
        }
      }

      return nextCell;
    };

    this.getNextOutsideTabbableElement = function (shiftKey) {
      var tabbableElements = (0, _tabbable.tabbable)(document);
      var nextElement;
      (0, _forEach.default)(tabbableElements).call(tabbableElements, function (element, index) {
        if (element.contains(document.activeElement)) {
          var currIndex = index;

          while (currIndex >= 0 && currIndex < tabbableElements.length && _this.gridNode.contains(tabbableElements[currIndex])) {
            currIndex += shiftKey ? -1 : 1;
          }

          nextElement = tabbableElements[currIndex];
        }
      });
      return nextElement;
    };

    this.getParentCell = function (element) {
      return _this.getCellProperties(_this.findClosestMatch(element, _this.cellSelector));
    };

    this.findClosestMatch = function (element, selector) {
      if (element.matches && element.matches(selector)) {
        return element;
      }

      if (element.parentNode) {
        return _this.findClosestMatch(element.parentNode, selector);
      }

      return null;
    };

    this.attachTo(options);
  }

  (0, _createClass2.default)(GridManager, [{
    key: "attachTo",
    value: function attachTo(_ref2) {
      var _ref2$gridNode = _ref2.gridNode,
          gridNode = _ref2$gridNode === void 0 ? null : _ref2$gridNode,
          _ref2$firstFocusedEle = _ref2.firstFocusedElement,
          firstFocusedElement = _ref2$firstFocusedEle === void 0 ? null : _ref2$firstFocusedEle,
          _ref2$firstFocusedCoo = _ref2.firstFocusedCoordinates,
          firstFocusedCoordinates = _ref2$firstFocusedCoo === void 0 ? {
        row: 0,
        col: 0
      } : _ref2$firstFocusedCoo,
          _ref2$firstCellSearch = _ref2.firstCellSearchDirection,
          firstCellSearchDirection = _ref2$firstCellSearch === void 0 ? {
        directionX: 0,
        directionY: 0
      } : _ref2$firstCellSearch,
          _ref2$rowNavigation = _ref2.rowNavigation,
          rowNavigation = _ref2$rowNavigation === void 0 ? false : _ref2$rowNavigation,
          _ref2$enableHeaderCel = _ref2.enableHeaderCells,
          enableHeaderCells = _ref2$enableHeaderCel === void 0 ? true : _ref2$enableHeaderCel,
          _ref2$skipFirstColumn = _ref2.skipFirstColumnTabbing,
          skipFirstColumnTabbing = _ref2$skipFirstColumn === void 0 ? true : _ref2$skipFirstColumn,
          _ref2$focusOnInit = _ref2.focusOnInit,
          focusOnInit = _ref2$focusOnInit === void 0 ? false : _ref2$focusOnInit,
          _ref2$wrapRows = _ref2.wrapRows,
          wrapRows = _ref2$wrapRows === void 0 ? false : _ref2$wrapRows,
          _ref2$wrapCols = _ref2.wrapCols,
          wrapCols = _ref2$wrapCols === void 0 ? false : _ref2$wrapCols,
          _ref2$onFocusCell = _ref2.onFocusCell,
          onFocusCell = _ref2$onFocusCell === void 0 ? function () {} : _ref2$onFocusCell,
          _ref2$onKeyDownCell = _ref2.onKeyDownCell,
          onKeyDownCell = _ref2$onKeyDownCell === void 0 ? function () {} : _ref2$onKeyDownCell,
          _ref2$onPassBoundary = _ref2.onPassBoundary,
          onPassBoundary = _ref2$onPassBoundary === void 0 ? function () {} : _ref2$onPassBoundary,
          _ref2$onClickRow = _ref2.onClickRow,
          onClickRow = _ref2$onClickRow === void 0 ? function () {} : _ref2$onClickRow,
          _ref2$onToggleEditMod = _ref2.onToggleEditMode,
          onToggleEditMode = _ref2$onToggleEditMod === void 0 ? function () {} : _ref2$onToggleEditMod,
          _ref2$disabledCells = _ref2.disabledCells,
          disabledCells = _ref2$disabledCells === void 0 ? [] : _ref2$disabledCells;

      if (gridNode) {
        var _context3;

        this.gridNode = gridNode;
        this.rowNavigation = rowNavigation;
        this.enableHeaderCells = enableHeaderCells;
        this.skipFirstColumnTabbing = skipFirstColumnTabbing;
        this.cellSelector = (0, _concat.default)(_context3 = "".concat(_constants.GridSelector.CELL, ", ")).call(_context3, this.enableHeaderCells && _constants.GridSelector.HEADER);
        this.wrapRows = wrapRows;
        this.wrapCols = wrapCols;
        this.onFocusCell = onFocusCell;
        this.onKeyDownCell = onKeyDownCell;
        this.onPassBoundary = onPassBoundary;
        this.onClickRow = onClickRow;
        this.onToggleEditMode = onToggleEditMode;
        this.disabledCells = disabledCells;
        this.focusedRow = 0;
        this.focusedCol = 0;
        this.editMode = false;
        this.setupFocusGrid();

        if (this.grid.length) {
          var firstFocusedCell = this.getCellProperties(firstFocusedElement);

          if (!firstFocusedCell) {
            var _this$grid$firstFocus;

            firstFocusedCell = {
              row: firstFocusedCoordinates.row,
              col: firstFocusedCoordinates.col,
              element: this.grid[firstFocusedCoordinates.row] ? (_this$grid$firstFocus = this.grid[firstFocusedCoordinates.row][firstFocusedCoordinates.col]) === null || _this$grid$firstFocus === void 0 ? void 0 : _this$grid$firstFocus.element : null
            };
          }

          if (!this.isValidCell(firstFocusedCell) || this.isDisabledCell(firstFocusedCell.element)) {
            firstFocusedCell = this.getNextCell(firstFocusedCell, firstCellSearchDirection.directionX, firstCellSearchDirection.directionY);
          }

          this.setFocusPointer(firstFocusedCell.row, firstFocusedCell.col);

          if (focusOnInit) {
            this.focusCell(firstFocusedCell);
          }

          this.registerEvents();
        }
      }
    }
  }, {
    key: "isDisabledCell",
    value: function isDisabledCell(element) {
      var _context4;

      var isDisabled = false;
      (0, _forEach.default)(_context4 = this.disabledCells).call(_context4, function (cell) {
        if (cell.contains(element)) {
          isDisabled = true;
        }
      });
      return isDisabled;
    }
  }]);
  return GridManager;
}();

exports.default = GridManager;